import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { captureException, addBreadcrumb } from "./utils/sentry/sentryConfig";
import { initTheme } from "./utils/theme/theme";
import { initClarity } from "./utils/clarity/clarityConfig";
import { initAnalytics } from "./utils/analytics/analyticsConfig";

initTheme();
initClarity();
initAnalytics();

window.addEventListener("error", (event) => {
  addBreadcrumb("Global error caught", "error", "error", {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
  captureException(event.error || new Error(event.message), {
    tags: { error_type: "global_error" },
    extra: {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    },
    level: "error",
  });
});

window.addEventListener("unhandledrejection", (event) => {
  addBreadcrumb("Unhandled promise rejection", "error", "error", {
    reason: event.reason instanceof Error ? event.reason.message : String(event.reason),
  });
  captureException(event.reason || new Error("Unhandled promise rejection"), {
    tags: { error_type: "unhandled_promise_rejection" },
    extra: {
      reason: event.reason instanceof Error ? event.reason.message : String(event.reason),
    },
    level: "error",
  });
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
